(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/transcript-panel/components/transcript-ordered-thankyou.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/transcript-panel/components/transcript-ordered-thankyou.js');
'use strict';

const {
  TopBottomBorder
} = svs.myProfile.react.pages.myInformation.transcript;

const TranscriptOrderedThankYou = () => React.createElement(TopBottomBorder, null, "Tack f\xF6r din best\xE4llning. Vi arbetar p\xE5 att ta fram ditt  registerutdrag s\xE5 fort som m\xF6jligt. Du f\xE5r ett mail n\xE4r det \xE4r redo att laddas ned.");
svs.myProfile.react.pages.myInformation.transcript.TranscriptOrderedThankYou = TranscriptOrderedThankYou;

 })(window);